module.exports = __webpack_public_path__ + "static/media/มะโรง.834a0b49.jpg";